import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 15,
	viewBox: "0 0 17 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		opacity: .9,
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1904 3.19527C10.4507 2.93491 10.8728 2.93491 11.1332 3.19527L16.4666 8.5286C16.7268 8.78895 16.7268 9.21105 16.4666 9.4714L11.1332 14.8048C10.8728 15.0651 10.4507 15.0651 10.1904 14.8048C9.93002 14.5444 9.93002 14.1223 10.1904 13.8619L14.3856 9.66667H2.66178C2.2936 9.66667 1.99512 9.36819 1.99512 9C1.99512 8.63181 2.2936 8.33334 2.66178 8.33334H14.3856L10.1904 4.13807C9.93002 3.87772 9.93002 3.45562 10.1904 3.19527Z",
			fill: "white"
		})
	})
});
export { SvgRightArrow as ReactComponent };
